import { render, staticRenderFns } from "./TargetGroup.vue?vue&type=template&id=27bc7a34&scoped=true&"
import script from "./TargetGroup.vue?vue&type=script&lang=js&"
export * from "./TargetGroup.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroup.vue?vue&type=style&index=0&id=27bc7a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc7a34",
  null
  
)

export default component.exports